import { render, staticRenderFns } from "./ModalSuporteConvenioPlano.vue?vue&type=template&id=fa2bd7a8&scoped=true"
import script from "./ModalSuporteConvenioPlano.vue?vue&type=script&lang=ts"
export * from "./ModalSuporteConvenioPlano.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuporteConvenioPlano.vue?vue&type=style&index=0&id=fa2bd7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2bd7a8",
  null
  
)

export default component.exports